import gsap from "gsap";

const handleScaleAnimation = (el) => {
  const scaleElements = gsap.utils.toArray(el.querySelectorAll("[data-scale-index]")).sort((a, b) => {
    return parseInt(a.getAttribute("data-scale-index")) - parseInt(b.getAttribute("data-scale-index"));
  });

  gsap.set(scaleElements, { scale: 0.2, opacity: 0 });

  const timeline = gsap.timeline();

  timeline.to(scaleElements, {
    scale: 1,
    opacity: 1,
    duration: 1,
    ease: "back.out(1.4)",
    stagger: 0.3,
  });

  return timeline;
};

const syncRippleEffects = (sliderElement) => {
  const rippleContainer = sliderElement.querySelector("[data-ripple-sync]");
  if (!rippleContainer) return;

  const activeSlide = sliderElement.querySelector(".swiper-slide-active");
  if (!activeSlide) return;

  const imageContainer = activeSlide.querySelector(".image-container");
  if (!imageContainer) return;

  const rippleElements = rippleContainer.querySelectorAll(".ripple-element");
  const containerRect = imageContainer.getBoundingClientRect();
  const sliderRect = sliderElement.getBoundingClientRect();

  // If the container is not visible, call the function again
  if (containerRect.width === 0 || containerRect.height === 0) {
    requestAnimationFrame(() => syncRippleEffects(sliderElement));
    return;
  }

  const relativeLeft = containerRect.left - sliderRect.left;
  const relativeTop = containerRect.top - sliderRect.top;
  const centerX = relativeLeft + containerRect.width / 2;
  const centerY = relativeTop + containerRect.height / 2;

  rippleElements.forEach((ripple, index) => {
    const sizeMultiplier = parseFloat(ripple.dataset.sizeMultiplier) || 1.2;
    const baseSize = Math.min(containerRect.width, containerRect.height);
    const rippleSize = baseSize * sizeMultiplier;

    const isTabletOrBelow = window.innerWidth < 1290;
    const isMobile = window.innerWidth < 768;

    let rippleOffsets;
    if (isMobile) {
      rippleOffsets = [
        { x: 40, y: 15 },
        { x: 60, y: 25 },
      ];
    } else if (isTabletOrBelow) {
      rippleOffsets = [
        { x: 60, y: 20 },
        { x: 80, y: 35 },
      ];
    } else {
      rippleOffsets = [
        { x: 60, y: 40 },
        { x: 130, y: 70 },
      ];
    }

    const offset = rippleOffsets[index] || rippleOffsets[0];
    const offsetX = rippleSize / 2 + offset.x;
    const offsetY = rippleSize / 2 + offset.y;

    ripple.style.left = `${centerX - offsetX}px`;
    ripple.style.top = `${centerY - offsetY}px`;
    ripple.style.width = `${rippleSize}px`;
    ripple.style.height = `${rippleSize}px`;
  });
};

const createResizeObserver = (sliderElement) => {
  return new ResizeObserver((entries) => {
    requestAnimationFrame(() => {
      syncRippleEffects(sliderElement);
    });
  });
};

const initializeHeaderRippleEffects = () => {
  const headerSlider = document.querySelector("[data-header-slider]");
  if (!headerSlider) return;

  requestAnimationFrame(() => {
    syncRippleEffects(headerSlider);
  });

  const resizeObserver = createResizeObserver(headerSlider);
  resizeObserver.observe(headerSlider);

  const sliderContainer = headerSlider.querySelector(".swiper");
  if (sliderContainer) {
    resizeObserver.observe(sliderContainer);
  }
};

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll("[data-scale]").forEach((el) => {
    handleScaleAnimation(el);
  });

  initializeHeaderRippleEffects();
});
